import { connect } from 'react-redux'
import PupilsTable from './pupils-table'
import {
  getPupilsWithAllFilters,
  getSortBy,
  isThereHiddenPupils,
  isEveryoneSelected,
  isShowingSelected
} from '../pupils-component-redux/pupils-component.selectors'
import {
  selectAllPupils,
  deselectAllPupils,
  changeSortKey,
  loadMorePupils
} from '../pupils-component-redux/pupils-component.actions'

const mapStateToProps = state => {
  const pupils = getPupilsWithAllFilters(state)
  return {
    pupils,
    hideAllAction: isShowingSelected(state),
    sortBy: getSortBy(state),
    everyoneSelected: isEveryoneSelected(state),
    showLoadMore: isThereHiddenPupils(state)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  changeSortKey: (key, direction) => dispatch(changeSortKey(key, direction)),
  loadMoreAction: () => dispatch(loadMorePupils()),
  dispatch
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  allAction: () => {
    return !stateProps.everyoneSelected
      ? dispatchProps.dispatch(selectAllPupils())
      : dispatchProps.dispatch(deselectAllPupils())
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(PupilsTable)
